import * as r from 'ramda';
import { ReportLineChart } from './ReportLineChart';

export const StatisticsCard = ({ title, data, formatLabel, color, tooltipLabel }) => {
  const totalValue = r.sum(data.map((dataItem) => dataItem.Value));

  return (
    <div className="flex-1 px-4 py-5 rounded-lg bg-white shadow">
      <div className="text-sm font-medium text-gray-500">{title}</div>
      <div className="mt-2 text-4xl font-semibold text-gray-900">
        {formatLabel ? formatLabel(totalValue) : Math.round(totalValue)}
      </div>

      <div className="w-full h-48 mt-6">
        <ReportLineChart data={data} color={color} tooltipLabel={tooltipLabel} />
      </div>
    </div>
  );
};
